import { Fragment } from 'react';
interface Props {
  title: string;
}
export const SubHeading = ({ title }: Props) => {
  return (
    <Fragment>
      <h2 className="lil-text-s-28 sm:lil-text-s-20">{title}</h2>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./components/common/subHeading.tsx